import mem, { memClear } from 'mem/dist';

import * as API from '../api/VendorsApi';
import { StripeAccount } from '../types/Stripe';
import {
  BookingPlatformSupplier,
  BookingPlatfromActivities,
  Vendor,
} from '../types/Vendor';

export function fetchVendorsList(searchQuery: string) {
  return API.fetchVendorsList(searchQuery);
}

export function fetchVendorById(id) {
  return API.fetchVendorById(id);
}

export function updateVendor(vendor) {
  return API.updateVendor(vendor);
}

export async function getStripeConnectedAccounts(): Promise<StripeAccount[]> {
  return API.getStripeConnectedAccounts();
}

export async function getFareHarborCompanies() {
  return API.getFareHarborCompanies();
}

export async function associateStripeAccountWithFareharborCompany(
  selectedStripeAccountId,
  companyToAssociateWith
) {
  return API.associateStripeAccountWithFareharborCompany(
    selectedStripeAccountId,
    companyToAssociateWith
  );
}

export async function updateBookingVendor(vendor: Vendor): Promise<Vendor> {
  memClear(memoizedGetFranchiseVendors);
  return API.updateBookingVendor(vendor);
}

export const memoizedGetSuppliers = mem(API.getSuppliers, {
  maxAge: 1000 * 60,
});
export function getSuppliers(
  bookingPlatformType: string
): Promise<BookingPlatformSupplier[]> {
  return memoizedGetSuppliers(bookingPlatformType);
}

export function getBookingPlatformActivities(
  vendorId: string
): Promise<BookingPlatfromActivities[]> {
  return API.getBookingPlatformActivities(vendorId);
}

export function getActivityFromBookingPlatform(
  vendorId: string,
  itemId: string,
  bookingPlatformType: string
) {
  return API.getActivityFromBookingPlatform(
    vendorId,
    itemId,
    bookingPlatformType
  );
}

const memoizedGetPricingTables = mem(API.getPricingTables, {
  maxAge: 1000 * 60,
});
export const getPricingTables = () => {
  return memoizedGetPricingTables();
};

const memoizedGetFranchiseVendors = mem(API.getFranchiseVendors, {
  maxAge: 1000 * 60,
});
export const getFranchiseVendors = () => {
  return memoizedGetFranchiseVendors();
};
